import { render, staticRenderFns } from "./SleSupplyChainIndex.vue?vue&type=template&id=1b645ace&"
import script from "./SleSupplyChainIndex.vue?vue&type=script&lang=js&"
export * from "./SleSupplyChainIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports